import { render, staticRenderFns } from "./piece-form.vue?vue&type=template&id=218cfcf8"
import script from "./piece-form.vue?vue&type=script&lang=js"
export * from "./piece-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports